"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../createApi");

var EventsApi = function (_BaseApi) {
  (0, _inherits2["default"])(EventsApi, _BaseApi);

  function EventsApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, EventsApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(EventsApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getEvents", function (_ref) {
      var clientId = _ref.clientId,
          page = _ref.page,
          without_video_conference = _ref.without_video_conference,
          video_conference = _ref.video_conference,
          after = _ref.after;
      return _this.api.get('/trainme/events', {
        params: {
          clientId: clientId,
          page: page,
          without_video_conference: without_video_conference,
          video_conference: video_conference,
          after: after
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserEvents", function (_ref2) {
      var clientId = _ref2.clientId,
          userId = _ref2.userId,
          page = _ref2.page,
          before = _ref2.before,
          after = _ref2.after;
      return _this.api.get("/trainme/users/".concat(userId, "/events"), {
        params: {
          clientId: clientId,
          page: page,
          before: before,
          after: after
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOneEvent", function (_ref3) {
      var clientId = _ref3.clientId,
          eventId = _ref3.eventId;
      return _this.api.get("/trainme/events/".concat(eventId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "registerEvent", function (_ref4) {
      var clientId = _ref4.clientId,
          eventId = _ref4.eventId;
      return _this.api.post("/trainme/events/".concat(eventId, "/users"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "unregisterEvent", function (_ref5) {
      var clientId = _ref5.clientId,
          eventId = _ref5.eventId;
      return _this.api["delete"]("/trainme/events/".concat(eventId, "/users"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUsersRegisteredToEvent", function (_ref6) {
      var clientId = _ref6.clientId,
          eventId = _ref6.eventId,
          limit = _ref6.limit,
          skip = _ref6.skip;
      return _this.api.get("/events/".concat(eventId, "/users"), {
        params: {
          clientId: clientId,
          limit: limit,
          skip: skip
        }
      });
    });
    return _this;
  }

  return EventsApi;
}(_createApi.BaseApi);

var _default = EventsApi;
exports["default"] = _default;
//# sourceMappingURL=events.js.map